// IQ Assessment Questions - Mix of logical reasoning, pattern recognition, and cognitive abilities
export const iqAssessmentQuestions = [
  {
    id: 1,
    category: "Pattern Recognition",
    question: "What comes next in this sequence: 2, 4, 8, 16, ?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "24", explanation: "This doesn't follow the pattern" },
      { option: "B", text: "30", explanation: "This doesn't follow the pattern" },
      { option: "C", text: "32", explanation: "Each number doubles (2×2=4, 4×2=8, 8×2=16, 16×2=32)" },
      { option: "D", text: "20", explanation: "This doesn't follow the pattern" }
    ]
  },
  {
    id: 2,
    category: "Logical Reasoning",
    question: "If all roses are flowers, and some flowers are red, which statement must be true?",
    correctAnswer: "D",
    options: [
      { option: "A", text: "All roses are red", explanation: "Not necessarily true based on the given information" },
      { option: "B", text: "Some roses are red", explanation: "Not necessarily true based on the given information" },
      { option: "C", text: "All flowers are roses", explanation: "This contradicts the given information" },
      { option: "D", text: "Some roses might be red", explanation: "This is the only statement that logically follows" }
    ]
  },
  {
    id: 3,
    category: "Spatial Reasoning",
    question: "If you fold a piece of paper in half twice and then cut a triangle from the corner, how many triangles will you see when you unfold it?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "1", explanation: "Too few - consider the folding" },
      { option: "B", text: "2", explanation: "Too few - think about each fold" },
      { option: "C", text: "4", explanation: "Two folds create 4 layers, so 4 triangles" },
      { option: "D", text: "8", explanation: "Too many for this folding pattern" }
    ]
  },
  {
    id: 4,
    category: "Mathematical Logic",
    question: "In a race, you pass the person in 2nd place. What place are you in now?",
    correctAnswer: "B",
    options: [
      { option: "A", text: "1st place", explanation: "Think again - you passed 2nd place, not 1st" },
      { option: "B", text: "2nd place", explanation: "You take their position when you pass them" },
      { option: "C", text: "3rd place", explanation: "You were behind 2nd, but now you've passed them" },
      { option: "D", text: "Can't determine", explanation: "There's enough information to solve this" }
    ]
  },
  {
    id: 5,
    category: "Pattern Recognition",
    question: "Complete the pattern: A1, B4, C9, D16, ?",
    correctAnswer: "B",
    options: [
      { option: "A", text: "E20", explanation: "Look at the relationship between letters and numbers" },
      { option: "B", text: "E25", explanation: "A=1², B=2², C=3², D=4², E=5²=25" },
      { option: "C", text: "F25", explanation: "Wrong letter in sequence" },
      { option: "D", text: "E30", explanation: "Not following the square pattern" }
    ]
  },
  {
    id: 6,
    category: "Logical Reasoning",
    question: "If it takes 5 machines 5 minutes to make 5 widgets, how long does it take 100 machines to make 100 widgets?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "100 minutes", explanation: "Think about the rate per machine" },
      { option: "B", text: "20 minutes", explanation: "Consider the relationship more carefully" },
      { option: "C", text: "5 minutes", explanation: "Each machine makes 1 widget in 5 minutes" },
      { option: "D", text: "1 minute", explanation: "Too fast based on the given rate" }
    ]
  },
  {
    id: 7,
    category: "Spatial Reasoning",
    question: "Which word does NOT belong with the others?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "Cat", explanation: "This fits with the pattern" },
      { option: "B", text: "Dog", explanation: "This fits with the pattern" },
      { option: "C", text: "Bird", explanation: "Unlike the others, birds are not mammals" },
      { option: "D", text: "Horse", explanation: "This fits with the pattern" }
    ]
  },
  {
    id: 8,
    category: "Mathematical Logic",
    question: "What number should replace the question mark? 3, 7, 15, 31, ?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "47", explanation: "Look for the pattern in differences" },
      { option: "B", text: "55", explanation: "Not following the correct pattern" },
      { option: "C", text: "63", explanation: "Pattern: ×2+1 (3×2+1=7, 7×2+1=15, 15×2+1=31, 31×2+1=63)" },
      { option: "D", text: "62", explanation: "Close but not the right pattern" }
    ]
  },
  {
    id: 9,
    category: "Logical Reasoning",
    question: "If some athletes are runners, and all runners are fast, which must be true?",
    correctAnswer: "B",
    options: [
      { option: "A", text: "All athletes are fast", explanation: "Not all athletes are runners" },
      { option: "B", text: "Some athletes are fast", explanation: "The athlete-runners must be fast" },
      { option: "C", text: "All fast people are athletes", explanation: "This reverses the logic incorrectly" },
      { option: "D", text: "No athletes are fast", explanation: "This contradicts the given information" }
    ]
  },
  {
    id: 10,
    category: "Pattern Recognition",
    question: "Find the missing number: 2, 6, 12, 20, 30, ?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "38", explanation: "Look at the pattern of differences" },
      { option: "B", text: "40", explanation: "Not following the sequence pattern" },
      { option: "C", text: "42", explanation: "Pattern: n×(n+1) where n starts at 1 (1×2, 2×3, 3×4, 4×5, 5×6, 6×7=42)" },
      { option: "D", text: "45", explanation: "Doesn't match the sequence pattern" }
    ]
  },
  {
    id: 11,
    category: "Logical Reasoning",
    question: "All birds can fly. Penguins are birds. What can we conclude?",
    correctAnswer: "D",
    options: [
      { option: "A", text: "Penguins can fly", explanation: "This follows the logical premise but contradicts reality" },
      { option: "B", text: "Penguins cannot fly", explanation: "This is true in reality but doesn't follow the given premise" },
      { option: "C", text: "The premise is wrong", explanation: "We must work with the given information" },
      { option: "D", text: "There's a contradiction in the given information", explanation: "This identifies the logical inconsistency" }
    ]
  },
  {
    id: 12,
    category: "Mathematical Logic",
    question: "If 3x + 7 = 22, what is the value of x?",
    correctAnswer: "B",
    options: [
      { option: "A", text: "4", explanation: "Check: 3(4) + 7 = 19, not 22" },
      { option: "B", text: "5", explanation: "Check: 3(5) + 7 = 22 ✓" },
      { option: "C", text: "6", explanation: "Check: 3(6) + 7 = 25, not 22" },
      { option: "D", text: "7", explanation: "Check: 3(7) + 7 = 28, not 22" }
    ]
  },
  {
    id: 13,
    category: "Pattern Recognition",
    question: "What comes next in the sequence: Z, Y, X, W, ?",
    correctAnswer: "A",
    options: [
      { option: "A", text: "V", explanation: "The alphabet is going backwards: Z, Y, X, W, V" },
      { option: "B", text: "U", explanation: "This skips a letter in the backward sequence" },
      { option: "C", text: "T", explanation: "This goes too far back in the sequence" },
      { option: "D", text: "X", explanation: "This repeats a previous letter" }
    ]
  },
  {
    id: 14,
    category: "Spatial Reasoning",
    question: "A cube has how many faces?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "4", explanation: "This is the number of faces on a tetrahedron" },
      { option: "B", text: "5", explanation: "This is incorrect for a cube" },
      { option: "C", text: "6", explanation: "A cube has 6 faces: top, bottom, front, back, left, right" },
      { option: "D", text: "8", explanation: "This is the number of vertices (corners) on a cube" }
    ]
  },
  {
    id: 15,
    category: "Logical Reasoning",
    question: "If today is Wednesday, what day will it be 100 days from now?",
    correctAnswer: "B",
    options: [
      { option: "A", text: "Tuesday", explanation: "Count the days more carefully" },
      { option: "B", text: "Friday", explanation: "100 ÷ 7 = 14 remainder 2, so 2 days after Wednesday is Friday" },
      { option: "C", text: "Saturday", explanation: "This is 3 days after Wednesday" },
      { option: "D", text: "Sunday", explanation: "This is 4 days after Wednesday" }
    ]
  },
  {
    id: 16,
    category: "Mathematical Logic",
    question: "What is 15% of 200?",
    correctAnswer: "B",
    options: [
      { option: "A", text: "25", explanation: "This would be 12.5% of 200" },
      { option: "B", text: "30", explanation: "15% of 200 = 0.15 × 200 = 30" },
      { option: "C", text: "35", explanation: "This would be 17.5% of 200" },
      { option: "D", text: "40", explanation: "This would be 20% of 200" }
    ]
  },
  {
    id: 17,
    category: "Pattern Recognition",
    question: "Complete the series: 1, 4, 9, 16, 25, ?",
    correctAnswer: "D",
    options: [
      { option: "A", text: "30", explanation: "This doesn't follow the square number pattern" },
      { option: "B", text: "32", explanation: "This doesn't follow the square number pattern" },
      { option: "C", text: "35", explanation: "This doesn't follow the square number pattern" },
      { option: "D", text: "36", explanation: "These are perfect squares: 1², 2², 3², 4², 5², 6² = 36" }
    ]
  },
  {
    id: 18,
    category: "Logical Reasoning",
    question: "If some doctors are teachers, and all teachers are smart, which must be true?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "All doctors are smart", explanation: "Only some doctors are teachers" },
      { option: "B", text: "All smart people are doctors", explanation: "This reverses the logic incorrectly" },
      { option: "C", text: "Some doctors are smart", explanation: "The doctor-teachers must be smart" },
      { option: "D", text: "No doctors are smart", explanation: "This contradicts the given information" }
    ]
  },
  {
    id: 19,
    category: "Spatial Reasoning",
    question: "Which shape has the most sides?",
    correctAnswer: "D",
    options: [
      { option: "A", text: "Triangle", explanation: "A triangle has 3 sides" },
      { option: "B", text: "Square", explanation: "A square has 4 sides" },
      { option: "C", text: "Pentagon", explanation: "A pentagon has 5 sides" },
      { option: "D", text: "Hexagon", explanation: "A hexagon has 6 sides, the most among these options" }
    ]
  },
  {
    id: 20,
    category: "Mathematical Logic",
    question: "If a train travels 60 miles in 1 hour, how far will it travel in 2.5 hours at the same speed?",
    correctAnswer: "C",
    options: [
      { option: "A", text: "120 miles", explanation: "This is the distance in 2 hours, not 2.5 hours" },
      { option: "B", text: "130 miles", explanation: "This doesn't use the correct calculation" },
      { option: "C", text: "150 miles", explanation: "60 miles/hour × 2.5 hours = 150 miles" },
      { option: "D", text: "160 miles", explanation: "This exceeds the correct calculation" }
    ]
  }
];

